import React, { useEffect, useState } from 'react';
import api from '../../api/client';
import Button from '../../components/Button';

function fmt(d) {
  if (!d) return '–';
  // Backend liefert naive UTC-Zeitstempel ohne Zeitzonen-Suffix – als UTC parsen
  // und explizit als deutsche Ortszeit (Europe/Berlin) anzeigen, unabhängig von
  // der Zeitzone des Browsers.
  const isoUtc = /[zZ]|[+-]\d\d:?\d\d$/.test(d) ? d : `${d}Z`;
  return new Date(isoUtc).toLocaleString('de-DE', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
    timeZone: 'Europe/Berlin',
  });
}

const ACTION_COLOR = {
  login: 'text-emerald-600', register: 'text-ocean-600', login_failed: 'text-red-500',
  ticket_booked: 'text-sand-700', payment_confirmed: 'text-emerald-600', payment_rejected: 'text-red-500',
  checkin: 'text-reef-600',
};

export default function AdminLogs() {
  const [logs, setLogs] = useState([]);
  const [total, setTotal] = useState(0);
  const [offset, setOffset] = useState(0);
  const limit = 50;

  const load = (off = 0) => {
    api.get(`/api/admin/logs?limit=${limit}&offset=${off}`).then((r) => { setLogs(r.data.items); setTotal(r.data.total); setOffset(off); });
  };
  useEffect(() => { load(); }, []);

  return (
    <div>
      <h2 className="page-title">Audit-Logs</h2>
      <p className="text-sm text-slate-500 mb-4">{total} Einträge gesamt</p>

      <div className="card overflow-x-auto p-0" style={{ WebkitOverflowScrolling: 'touch' }}>
        <table className="w-full text-xs">
          <thead className="bg-slate-50 border-b border-slate-100">
            <tr>
              {['Zeit', 'Aktion', 'User', 'Ressource', 'Details', 'IP'].map((h) => (
                <th key={h} className="text-left px-4 py-2.5 font-semibold text-slate-500 whitespace-nowrap">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {logs.map((l) => (
              <tr key={l.id} className="border-b border-slate-50 hover:bg-slate-50/50 transition-colors">
                <td className="px-4 py-2 text-slate-400 whitespace-nowrap">{fmt(l.created_at)}</td>
                <td className={`px-4 py-2 font-semibold whitespace-nowrap ${ACTION_COLOR[l.action] || 'text-slate-600'}`}>{l.action}</td>
                <td className="px-4 py-2 text-slate-700 font-medium">{l.username || l.user_id || '–'}</td>
                <td className="px-4 py-2 text-slate-500">{l.resource_type}{l.resource_id ? ` #${l.resource_id}` : ''}</td>
                <td className="px-4 py-2 text-slate-400 max-w-xs truncate">{l.details || '–'}</td>
                <td className="px-4 py-2 font-mono text-slate-400">{l.ip_address || '–'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="flex items-center justify-center gap-4 mt-4">
        <Button variant="ghost" size="sm" disabled={offset === 0} onClick={() => load(offset - limit)}>← Zurück</Button>
        <span className="text-sm text-slate-500">{offset + 1}–{Math.min(offset + limit, total)} / {total}</span>
        <Button variant="ghost" size="sm" disabled={offset + limit >= total} onClick={() => load(offset + limit)}>Weiter →</Button>
      </div>
    </div>
  );
}
